import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';
import * as React from 'react';
import pxToRem from 'assets/theme/function/px-to-rem';
import DialogIconClose from 'component/dialog-icon-close';
import { UrlObject } from 'pages/card';

interface Props {
    imageUrl: UrlObject;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ViewPhoto: React.FC<Props> = (props: Props) => {
    const { imageUrl, open, setOpen } = props;
    const closeDialog = () => {
        setOpen(false);
    };

    return (
        <>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <Box display={'flex'} justifyContent={'center'}>
                    <DialogTitle textTransform={'uppercase'}>
                        {imageUrl.title}
                    </DialogTitle>
                    <DialogIconClose handleClose={closeDialog} />
                </Box>

                <DialogContent sx={{ paddingY: pxToRem(20) }}>
                    <Box
                        component="img"
                        src={imageUrl.url}
                        alt="Preview"
                        sx={{
                            width: '100%',
                            height: 'auto',
                            display: 'block',
                            maxHeight: '80vh',
                            objectFit: 'contain',
                        }}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ViewPhoto;
